import React , { useState ,  useContext , useEffect} from 'react';
import { AppContext } from '../context/AppContext';
import {   db , setDoc , doc , getDocs , collection , deleteDoc  } from '../firebase';
import Footer from '../components/Footer'
import NavbarHome from '../components/HomeComponents/NavbarHome'
import { Navigate, useNavigate } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const ConfirmOrder = () => {

  const user = JSON.parse(localStorage.getItem("tourst_compass_user"));

    let navigate = useNavigate();

    const [nextTo , setNextTo ] = useState(false);
    const [cartItems , setCartItems ] = useState([]);
    
    const [startDate, setStartDate] = useState(new Date());

    const [ clientName , setClientName ] = useState('');
    const [ clientPhoneNumber , setClientPhoneNumber ] = useState('');
    const [ mapRating , setMapRating ] = useState('');
    const [ serviceRating , setServiceRating ] = useState('');
    const [loading , setLoading] = useState(false);
    const [error , setError] = useState('');
    const [success , setSuccess ] = useState(false);

    const [priceValue , setPriceValue ] = useState(0);



  const makeid = (length) =>  {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * 
 charactersLength));
   }
   return result;
}

const totalPrice = (array) => {
  const prices = array.map((item) => parseInt(item.price));
  let totalValue  = prices.reduce((a, b) => a + b);
  setPriceValue(totalValue);
};

useEffect(() => {

  const getUsersOrders = async () => { 
    const querySnapshot = await getDocs(collection(db, `cart ${user.id}` ));
    const ordersDataArray = querySnapshot.docs
    .map((doc) => ({ ...doc.data(), id: doc.id }));

    totalPrice(ordersDataArray);

    setCartItems(ordersDataArray);

   
  }
  getUsersOrders();


} , [cartItems]);

async function deleteCollection() {
  const querySnapshot = await getDocs(collection(db, `cart ${user.id}` ));
  querySnapshot.forEach(async (doc) => {
    await deleteDoc(doc.ref);
  });
}


  const submitOrder = async (e) => {
    e.preventDefault();

    setLoading(true);

if (clientName === ''  ) {
  setError(' يرجى ادخال اسم مقدم للطلب ');
}

if (clientPhoneNumber === ''  ) {
  setError(' يرجى ادخال رقم هاتف مقدم للطلب ');
}

setTimeout(() => {
  setLoading(false);
  setError('');
} , 2500)

    if (clientName !== '' && clientPhoneNumber !== '' ) {

      let idMaked = makeid(20);
      
        const orders = await setDoc(doc(db, "orders", idMaked ), {

          name: clientName,
          phone_number: clientPhoneNumber,
          // map_rating: mapRating,
          // service_rating: serviceRating,
          orders: cartItems,
          date: startDate,
          totalPrice: priceValue,
          client_id : user.id,
          
         
          });

          deleteCollection();

        
        
            setSuccess(true);
            setLoading(false);
            setError('');

            setTimeout(() => {
                setSuccess('');
              


          navigate(`/order/${idMaked}`);


            } , 1350);

         

    }

  }

  const removeCartFromDb = async (id) => { 
 
    await deleteDoc(doc(db, `cart ${user.id}`, id ));
  
  }



  return (
    <div className="main_homepage" >


    <NavbarHome />


    <div className='container-sm' >

      <div className="text-center top_area_slide_two">
        <img src="/images/icons/logo.png" alt="" className="icon_big" />
        <h1 className="location_slidetwo_headline"> البوصلة السياحية</h1>
      
      </div>

      <div className="mt-3"></div>
      {cartItems.length != 0 && (
        <h1 className="location_slidetwo_headline ">  المتابعة لطلبك  </h1>
      ) }
    
      {cartItems.length != 0 ? (
        <div className="grid_invoice_section mt-5">
        <h1 className="location_slidetwo_headline border_b">  السعر </h1>
        <h1 className="location_slidetwo_headline border_b">اسم المنتج</h1>
      
      </div>
      ) : ''}
     

      <div className="grid_invoice_section mt-2">

      {cartItems.length != 0 ? cartItems.map(( { id , name , price , service_provider } ) => (
        <>
        <p className="main_para">   SAR {price}   </p>
      <p className="main_para"> حجز {service_provider} - {name}  - <br />  <button  className="mt-1 btn_pricing mx-2 bg_red w-30" onClick={() => removeCartFromDb(id ) }  > ❌ الغاء   </button>   </p>
     
        </>

      )) : ''}
      
     

     

      
      </div>

      {error && (
                            <>
                            <h1 className="mb-1 error_headline"> {error} </h1>
                            </>
                        )}

                {success && (
                    <>
                        <div className="popup_success">
                            <img src="/images/icons/check.png" alt="" />
                        </div>
                    </>
                )}

      {cartItems.length == 0 && (
        <p className="main_para"> لم تقم بطلب شئ حتى الان , يمكنك تصفح بكجاتنا واختيار منتج </p>
      ) }
      <div className="text-right my-3">
    
      <p className="main_para">المجموع كامل : {priceValue} ريال</p>
      </div>

     

      { cartItems.length !== 0 ? nextTo ? (

        <form onSubmit={submitOrder} >
        
      <div className="input_form_div">
          <label htmlFor="" className="login_label_form">اسم مقدم الطلب</label>
          <input value={clientName} onChange={(e) => setClientName(e.target.value) } type="text" className="login_input_form " placeholder='يرجى كتابة اسمك كمقدم للطلب' />
        </div>

      <div className="input_form_div">
          <label htmlFor="" className="login_label_form">رقم هاتف مقدم الطلب</label>
          <input value={clientPhoneNumber} onChange={(e) => setClientPhoneNumber(e.target.value) } type="number" placeholder='05xxxxxxxx' className="login_input_form " />
        </div>

      <div className="input_form_div">
          <label htmlFor="" className="login_label_form">  حاب تكون رحلتك بأي تاريخ ؟</label>
          <input className='login_input_form' type="date" value={startDate} onChange={(e) =>  setStartDate(e.target.value)} />

        </div>

        {/* <div className="input_form_div">
          <label htmlFor="" className="login_label_form"> تقييمك للخريطة الخاصة بنا ؟</label>
          <input value={mapRating} onChange={(e) => setMapRating(e.target.value) } type="text" className="login_input_form " placeholder='عطنا تقييم لخريطتنا وكيف ممكن نحسنها ؟' style={{ height: '5rem' }} />
        </div>

        <div className="input_form_div">
          <label htmlFor="" className="login_label_form">  عطنا اي ملاحظات لتحسين خدماتنا ؟ </label>
          <input value={serviceRating} onChange={(e) => setServiceRating(e.target.value) } type="text" className="login_input_form " placeholder='عطنا اي ملاحظات لتحسين خدماتنا' style={{ height: '5rem' }} />
        </div> */}

        <div className='input_form_div' >

        {loading ? (
              <>
                                <img src="/images/icons/loading-spinner.gif" className='loading_spinner' alt="" />
                            </>
            ) : (
              <button type='submit' className="mt-2 btn_login w-30">   تقديم الطلب </button>
            )}

        
        </div>

       
      </form>
      ) : (
        <div className="text-center btn_pay mt-3 mb-5" onClick={() => setNextTo(!nextTo) } >المتابعة الان</div>
      ) : ''}
     

       


    </div>
   





  

 



    <Footer />

    </div>
  )
}

export default ConfirmOrder